import { TodoListEntry } from "./TodoListEntry";
import { useFragment, useRelayEnvironment } from "react-relay";
import { TodoListData_todos$key } from "./__generated__/TodoListData_todos.graphql";

const fragment = graphql`
  fragment TodoListData_todos on TodoConnection {
    edges {
      node {
        id
        ...TodoListEntry_todo
      }
    }
  }
`;

export type Props = {
  todos: TodoListData_todos$key;
};

export function TodoListData({ todos: todosRef }: Props) {
  const todos = useFragment(fragment, todosRef);
  const environment = useRelayEnvironment();
  const { edges } = todos;
  if (!edges) {
    return <div>...</div>;
  }

  return (
    <>
      {edges.map((edge, index) => {
        if (!edge || !edge.node) {
          return <span key={`empty-${index}`}>...</span>;
        }

        return (
          <TodoListEntry
            key={edge.node.id}
            todo={edge.node}
            relayEnvironment={environment}
          />
        );
      })}
    </>
  );
}
